var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.locations.length > 0
        ? _c(
            "b-list-group",
            _vm._l(_vm.locations, function (loc) {
              return _c(
                "b-list-group-item",
                {
                  key: _vm.prefix + "-loc-" + loc.id,
                  staticClass:
                    "d-flex align-items-center justify-content-between",
                  class: { "location-locked": _vm.isLocked(loc.id) },
                },
                [
                  _c("div", { staticClass: "text-truncate pr-3" }, [
                    _c("div", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(loc.title) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-muted" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(loc.uniq_id) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.isLocked(loc.id)
                      ? _c("div", { staticClass: "text-danger small mt-1" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.__t("ALREADY_ATTACHED")) +
                              "\n                    " +
                              _vm._s(_vm.getAttachedName(loc.id)) +
                              "\n                    #" +
                              _vm._s(_vm.getAttachedSettingId(loc.id)) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-control custom-switch" }, [
                    _c("input", {
                      staticClass: "custom-control-input",
                      attrs: {
                        id: _vm.prefix + "-loc-" + loc.id,
                        type: "checkbox",
                        disabled: _vm.isLocked(loc.id),
                      },
                      domProps: { checked: _vm.isAttached(loc.id) },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("toggle", loc)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", {
                      staticClass: "custom-control-label",
                      attrs: { for: _vm.prefix + "-loc-" + loc.id },
                    }),
                  ]),
                ]
              )
            }),
            1
          )
        : _c("div", { staticClass: "alert alert-info mb-0" }, [
            _vm._v("\n        Немає локацій\n    "),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }